<div class="container">
  <div class="sub-title">
    {{ data.title | translate}}
  </div>  

  <div class="search">
    <app-input 
      [label]="'labels.search' | translate"
      [placeholder]="'placeholders.search' | translate"
      [formControl]="searchControl"
      type="text"
    ></app-input>
  </div>
  
    
  <div class="list-container">
    @for (item of list; track $index;) {
      <div class="item-container" (click)="select(item)">
        <div class="row">
          <span class="label">{{'labels.name' | translate}} </span>
          <span class="content">
            {{item.first_name + ' ' + item.last_name}}
          </span>
        </div>
        <div class="row">
          <span class="label">{{'labels.license' | translate}} </span>
          <span class="content">
            {{item.council_number +'/'+ item.council_country}}
          </span>
        </div>
        <div class="row">
          <span class="label">{{'labels.languages' | translate}} </span>
          <span class="content">
            {{getLanguageLabel(item.session_languages || [''])}}
          </span>
        </div>
        <div class="row">
          <span class="label">{{'labels.description_label' | translate}} </span>
          <span class="content">
            {{item.service_description}}
          </span>
        </div>
      </div>
    }
  </div>
    
  <div class="actions-container">
    <app-button 
      [buttonLabel]="'buttons.cancel' | translate"
      [buttonType]="BUTTON_TYPES.OUTLINED" 
      [buttonDisabled]="false"
      (click)="cancel()">
    </app-button>
  </div>
</div>
